import { render, staticRenderFns } from "./SPQUploadDialog.vue?vue&type=template&id=38443014&"
import script from "./SPQUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./SPQUploadDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports